var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignBottomSimple = function SvgIconAlignBottomSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 2a1.75 1.75 0 0 0-1.75 1.75v13.5c0 .966.784 1.75 1.75 1.75h6a1.75 1.75 0 0 0 1.75-1.75V3.75A1.75 1.75 0 0 0 15 2zm.25 15V4h5.5v13z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 20.75a1 1 0 1 0 0 2h13.5a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconAlignBottomSimple;